<template>
  <a-spin :spinning="boxSpinning">
    <div id="steps-first">
      <h1>基本信息</h1>
      <a-form-model ref="firstForm" :labelCol="{ span: 8 }" :wrapperCol="{ span: 10 }" :model="firstForm.data" :rules="firstForm.rules">
        <a-form-model-item label="报告类型" prop="reportType">
          <a-select :disabled="firstForm.reportTypeDisabled" v-model="firstForm.data.reportType" placeholder="请选择报告类型">
            <a-select-option :value="1">校级团体报告</a-select-option>
            <a-select-option :value="2">区域团体报告</a-select-option>
            <a-select-option :value="3">单校对比报告</a-select-option>
            <a-select-option :value="4">多校对比报告</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="名称CN" prop="nameCN">
          <a-input @change="(e) => (firstForm.data.nameCN = e.target.value.replace(/\s*/g, ''))" v-model="firstForm.data.nameCN" :maxLength="28" placeholder="不超过28个字符">
            <span class="input-number" slot="suffix"> {{ firstForm.data.nameCN ? firstForm.data.nameCN.length : 0 }} / 28 </span>
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="名称EN">
          <a-input @change="(e) => (firstForm.data.nameEN = e.target.value.replace(/\s*/g, ''))" v-model="firstForm.data.nameEN" :maxLength="35" placeholder="不超过35个字符">
            <span class="input-number" slot="suffix"> {{ firstForm.data.nameEN ? firstForm.data.nameEN.length : 0 }} / 35 </span>
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="项目名称" prop="projectName">
          <a-input v-model="firstForm.data.projectName" :maxLength="35" placeholder="不超过35个字符">
            <span class="input-number" slot="suffix"> {{ firstForm.data.projectName ? firstForm.data.projectName.length : 0 }} / 35 </span>
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="报告日期">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="reportTime" :wrapper-col="{ span: 24 }" style="margin-bottom: 0">
                <a-date-picker style="width: 100%" placeholder="请选择日期" v-model="firstForm.data.reportTime" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model-item>

        <a-form-model-item :wrapper-col="{ span: 10, offset: 8 }" style="text-align: right">
          <a-button @click="cancel" style="margin-right: 20px">取消</a-button>
          <a-button type="primary" @click="onSubmit">下一步</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-spin>
</template>

<script>
import { FormatDate } from '@/pages/projectImpl/js/utils'
import $Bus from '@/pages/projectImpl/js/eventBus'
import moment from 'moment'

export default {
  name: 'StepsFirst',
  data() {
    return {
      moment,
      reportId: this.$parent.$props.reportId,
      //表单加载loading
      boxSpinning: false,
      firstForm: {
        isNowTime: true,
        reportTypeDisabled: false,
        data: {
          id: '',
          // projectCourseConfigId: "",
          nameCN: '',
          nameEN: '',
          projectName: '',
          reportTime: FormatDate(Date.now(), 'YYYY-MM-DD'),
          reportType: 1,
          studentSampleTakingMethod: 0,
          correctionMethod: 1,
          // status: 0
        },
        rules: {
          nameCN: [
            { required: true, message: '请输入报告名称', trigger: 'blur' },
            { min: 2, max: 28, message: '报告名称长度为 2 到 28个字符', trigger: 'blur' },
            {
              validator: (_, value, callback) => {
                const reg = /^[a-zA-Z0-9\u4e00-\u9fa5()（）_]+$/
                if (!reg.test(value)) {
                  callback(new Error('报告名称不能包含特殊字符'))
                } else {
                  callback()
                }
              },
              trigger:"blur"
            },
          ],
          projectName: [
            { required: true, message: '请输入项目名称', trigger: 'blur' },
            { min: 2, max: 35, message: '项目名称长度为 2 到 35个字符', trigger: 'blur' },
          ],
          reportTime: [{ required: true, message: '请选择日期', trigger: 'change' }],
          reportType: [{ required: true, message: '请选择报告类型', trigger: 'change' }],
        },
      },
    }
  },
  mounted() {
    this.getModel()
  },
  methods: {
    //根据id获取团体报告信息
    getModel() {
      if (this.reportId) {
        this.boxSpinning = true
        this.$http.GroupReport.getModel({ id: this.reportId }).then((res) => {
          console.log(res.data)
          this.$store.commit('organization/setReportInfo', res.data)
          for (let key in this.firstForm.data) {
            this.firstForm.data[key] = res.data[key]
          }
          if (res.data.reportTime && res.data.reportTime.split(' ')[0] !== FormatDate(Date.now(), 'YYYY-MM-DD')) {
            this.firstForm.isNowTime = false
            this.firstForm.data.reportTime = moment(this.firstForm.data.reportTime, 'YYYY-MM-DD')
          }
          this.firstForm.reportTypeDisabled = true
        }).finally(() => {
          this.boxSpinning = false
        })
      } else {
        if (this.$store.getters['organization/getReportInfo'].id) {
          this.reportId = this.$store.getters['organization/getReportInfo'].id
          this.getModel()
        }
      }
    },
    //下一步
    onSubmit() {
      this.$refs['firstForm'].validate((valid) => {
        if (valid) {
          if (!this.reportId) {
            delete this.firstForm.data.id
          }
          const ReportInfo = this.$store.getters['organization/getReportInfo'] || {}
          for (let key in this.firstForm.data) {
            ReportInfo[key] = this.firstForm.data[key]
          }
          this.boxSpinning = true
          this.$http.GroupReport.groupReportEdit(ReportInfo).then((res) => {
            this.$parent.$data.current = 1
            ReportInfo.id = Number(res.data)
            this.$store.commit('organization/setReportInfo', ReportInfo)
          }).finally(() => {
            this.boxSpinning = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //取消
    cancel() {
      $Bus.$emit('closeCreateReport')
    },
    //报告日期单选框切换
    firstFormRadioChange(e) {
      this.$refs.firstForm.clearValidate('reportTime')
      this.firstForm.data.reportTime = undefined
      if (e.target.value) {
        this.firstForm.data.reportTime = FormatDate(Date.now(), 'YYYY-MM-DD')
      }
      this.firstForm.rules.reportTime[0].required = !e.target.value
    },
  },
}
</script>

<style lang="less" scoped>
#steps-first {
  h1 {
    font-size: 20px;
    color: #333;
    margin-bottom: 30px;
  }
}
.input-number {
  font-size: 13px;
  color: #bbb;
}
</style>
